let scrollbarWidth;
export function getScrollbarWidth() {
    scrollbarWidth = scrollbarWidth || (window.innerWidth - document.documentElement.clientWidth);
    return scrollbarWidth;
}